import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useAddCompany, useGetAdminCurencyList, useUpdateCompany } from "../SuperSettingsScreen/hook/useCompony";

interface CompanyTableModalContentProps {
  handleClose: () => void;
  status:string | null
  rowData:any
}
interface ReqBodyInterFace{
  CompanyCode: string,
  CompanyName: string,
  OwnerName: string,
  OwnerEmail: string,
  CompanyPhoneNumber: string,
  CompanyContactNumber:string,
  CompanyAddress1:string,
  CompanyAddress2:string,
  CompanyDefaultCurrency: number | null
}

interface formDataInterface{  
  code:string,
  company_name:string,
  OwnerName:string,
  Authorised_Signatory:string,
  Email:string,
  Phone_Number:number| undefined,
  Mobile:number | undefined,
  Address_Line_1:string,
  Address_Line_2:string,
  Default_Currency:number | null
}


const CompanyTableModalContent: React.FC<CompanyTableModalContentProps> = ({
  handleClose,
  status,
  rowData
}) => {
  

  
  useEffect(()=>{
      if(status == "Edit"){
        setFormData((prev:any)=>({
        ...prev,
        code:rowData.CompanyCode,
       company_name:rowData.CompanyName,
       OwnerName:rowData.OwnerName,
      //  Authorised_Signatory:rowData.,
       Email:rowData.OwnerEmail,
       Phone_Number:rowData.CompanyPhoneNumber,
       Mobile:rowData.CompanyContactNumber,
       Address_Line_1:rowData.CompanyAddress1,
       Address_Line_2:rowData.CompanyAddress2,
       Default_Currency:rowData.CompanyDefaultCurrency
        }))
      }
    },[status])

   const initialFormData:formDataInterface = {
    code:'',
    company_name:'',
    OwnerName:'',
    Authorised_Signatory:'',
    Email:'',
    Phone_Number:undefined,
    Mobile:undefined,
    Address_Line_1:'',
    Address_Line_2:'',
    Default_Currency:null
   }
   

  const [formData,setFormData] = useState<formDataInterface>(initialFormData);

  const {data,isLoading,isSuccess} = useGetAdminCurencyList({enable:true});
  const {mutate:addCompany} = useAddCompany();
  const {mutate:updateCompany} = useUpdateCompany();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
   
    const ReqBody:ReqBodyInterFace  = {
    CompanyCode: formData.code,
    CompanyName:formData.company_name,
    OwnerName:formData.OwnerName,
    OwnerEmail: formData.Email,
    CompanyPhoneNumber:String(formData.Phone_Number),
    CompanyContactNumber:String(formData.Mobile),
    CompanyAddress1:formData.Address_Line_1,
    CompanyAddress2:formData.Address_Line_2,
    CompanyDefaultCurrency: Number(formData.Default_Currency)
    }
     
   if(status ==='Add'){
    addCompany(ReqBody);
   }
   if(status === 'Edit'){
     const CompanyId = rowData.CompanyId    
     const updateReqBoady = { ...{CompanyId:CompanyId} , ...ReqBody};
     console.log('updateReqBoady',updateReqBoady);
     updateCompany(updateReqBoady)
   }
  
   handleClose();
   setFormData(initialFormData);
  };

  const handleInput = (filed:keyof formDataInterface, value:any)=>{
    setFormData((prev:any)=>({
                ...prev,
                [filed]:value
    }))
  }


  return (
    
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <div className="row mb-3">

        <div className="col-md-4">
          <label style={{ fontWeight: "500" }}>CODE<span style={{color:'red'}}>*</span> </label>
          <input
            value={formData.code}
            type="text"
            required  
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('code',e.target.value)}
            className="form-control"
            placeholder="Enter code"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
  
       <div className="col-md-4">
          <label style={{ fontWeight: "500" }}>Company Name</label>
          <input
            type="text"
            value={formData.company_name}
            className="form-control"
            placeholder="Enter company name"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('company_name',e.target.value)}  
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

       <div className="col-md-4">
          <label style={{ fontWeight: "500" }}>Owner Name</label>
          <input
            type="text"
            value={formData.OwnerName}
            className="form-control"
            placeholder="Enter owner name"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('OwnerName',e.target.value)}  
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>



      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Authorised Signatory</label>
          <input
            type="text"
            value={formData.Authorised_Signatory}
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Authorised_Signatory',e.target.value)}
            className="form-control"
            placeholder="Enter authorised signatory"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Email</label>
          <input
            type="email"
            className="form-control"
            value={formData.Email}
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Email',e.target.value)}
            placeholder="Enter Email"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Phone Number</label>
          <input
            type="number"
            pattern="\d{10}"
            className="form-control"
            value={formData.Phone_Number}
            placeholder="Enter Phone Number"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Phone_Number',e.target.value)}
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Mobile</label>
          <input
            type="number"
            className="form-control"
            value={formData.Mobile}
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Mobile',e.target.value)}
            placeholder="Enter Mobile"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Address Line 1</label>
          <input
            type="text"
            value={formData.Address_Line_1}
            className="form-control"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Address_Line_1',e.target.value)}
            placeholder="Enter Address Line 1"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Address Line 2</label>
          <input
            type="text"
            value={formData.Address_Line_2}
            className="form-control"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleInput('Address_Line_2',e.target.value)}
            placeholder="Enter Address Line 2"
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
              // textOverflow:'ellipsis',
              // textWrap:'nowrap'
            }}
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-12">
          <ReusableDropdown
            asterisk
            options={(!isLoading && isSuccess && data.formatedData)|| []}
             value={formData.Default_Currency}
            onChange={(value: any) => {
              console.log(value);
              handleInput('Default_Currency',value)
            }}
            DropdownHeading="Default Currency"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          // onClick={handleSubmit}
        >
          {status ==='Add' ? "Submit" :"Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>


  );
};

export default CompanyTableModalContent;
